import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { InvestmentInstructionSubmission } from '../../../../models/submissions/investment-instruction-submission';
import { BehaviorSubject } from 'rxjs';
import { filter, map } from 'rxjs/operators';

@Component({
  selector: 'app-investment-instruction-submission-allocation-changes',
  templateUrl: './investment-instruction-submission-allocation-changes.component.html',
  styleUrls: ['./investment-instruction-submission-allocation-changes.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class InvestmentInstructionSubmissionAllocationChangesComponent implements OnChanges {
  @Input() submission!: InvestmentInstructionSubmission;
  @Input() descriptionText: string = '';

  private _submission = new BehaviorSubject<InvestmentInstructionSubmission | null>(null);
  public submission$ = this._submission.pipe(filter((sub): sub is InvestmentInstructionSubmission => sub !== null));

  public previousAllocations$ = this.submission$.pipe(
    map(sub => sub.previous.rebalancingInstructions),
    map(instructions => instructions.slice().sort((a, b) => a.fundId - b.fundId))
  );

  public previousAllocationDonutChartData$ = this.previousAllocations$.pipe(
    map(allocations => allocations.map(allocation => allocation.asDonutChartData()))
  );

  public newAllocations$ = this.submission$.pipe(
    map(sub => sub.new.rebalancingInstructions),
    map(instructions => instructions.slice().sort((a, b) => a.fundId - b.fundId))
  );

  public newAllocationDonutChartData$ = this.newAllocations$.pipe(
    map(allocations => allocations.map(allocation => allocation.asDonutChartData()))
  );

  public allocationsHaveChanged$ = this.newAllocations$.pipe(map(newAllocations => !!newAllocations.length));

  public ngOnChanges(changes: SimpleChanges) {
    if (changes.submission) {
      this._submission.next(this.submission);
    }
  }
}
